/* @flow */
import React from 'react';
// $FlowIgnore
import { MdCallMade } from 'react-icons/md';

export default function ExternalLinkIcon({
  style
}: Object): React.Element {
  return <MdCallMade style={style} />;
}
